import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\WalletController::index
* @see app/Http/Controllers/WalletController.php:18
* @route '/wallet'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/wallet',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WalletController::index
* @see app/Http/Controllers/WalletController.php:18
* @route '/wallet'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WalletController::index
* @see app/Http/Controllers/WalletController.php:18
* @route '/wallet'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::index
* @see app/Http/Controllers/WalletController.php:18
* @route '/wallet'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\WalletController::index
* @see app/Http/Controllers/WalletController.php:18
* @route '/wallet'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::index
* @see app/Http/Controllers/WalletController.php:18
* @route '/wallet'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::index
* @see app/Http/Controllers/WalletController.php:18
* @route '/wallet'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\WalletController::topUp
* @see app/Http/Controllers/WalletController.php:47
* @route '/wallet/top-up'
*/
export const topUp = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: topUp.url(options),
    method: 'post',
})

topUp.definition = {
    methods: ["post"],
    url: '/wallet/top-up',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WalletController::topUp
* @see app/Http/Controllers/WalletController.php:47
* @route '/wallet/top-up'
*/
topUp.url = (options?: RouteQueryOptions) => {
    return topUp.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WalletController::topUp
* @see app/Http/Controllers/WalletController.php:47
* @route '/wallet/top-up'
*/
topUp.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: topUp.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\WalletController::topUp
* @see app/Http/Controllers/WalletController.php:47
* @route '/wallet/top-up'
*/
const topUpForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: topUp.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\WalletController::topUp
* @see app/Http/Controllers/WalletController.php:47
* @route '/wallet/top-up'
*/
topUpForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: topUp.url(options),
    method: 'post',
})

topUp.form = topUpForm

/**
* @see \App\Http\Controllers\WalletController::transactions
* @see app/Http/Controllers/WalletController.php:125
* @route '/wallet/transactions'
*/
export const transactions = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: transactions.url(options),
    method: 'get',
})

transactions.definition = {
    methods: ["get","head"],
    url: '/wallet/transactions',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WalletController::transactions
* @see app/Http/Controllers/WalletController.php:125
* @route '/wallet/transactions'
*/
transactions.url = (options?: RouteQueryOptions) => {
    return transactions.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WalletController::transactions
* @see app/Http/Controllers/WalletController.php:125
* @route '/wallet/transactions'
*/
transactions.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: transactions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::transactions
* @see app/Http/Controllers/WalletController.php:125
* @route '/wallet/transactions'
*/
transactions.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: transactions.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\WalletController::transactions
* @see app/Http/Controllers/WalletController.php:125
* @route '/wallet/transactions'
*/
const transactionsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: transactions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::transactions
* @see app/Http/Controllers/WalletController.php:125
* @route '/wallet/transactions'
*/
transactionsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: transactions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WalletController::transactions
* @see app/Http/Controllers/WalletController.php:125
* @route '/wallet/transactions'
*/
transactionsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: transactions.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

transactions.form = transactionsForm

const wallet = {
    index: Object.assign(index, index),
    topUp: Object.assign(topUp, topUp),
    transactions: Object.assign(transactions, transactions),
}

export default wallet